import { render, staticRenderFns } from "./personalAccountAnalysis.vue?vue&type=template&id=22dd2a2f&scoped=true&"
import script from "./personalAccountAnalysis.vue?vue&type=script&lang=js&"
export * from "./personalAccountAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./personalAccountAnalysis.vue?vue&type=style&index=0&id=22dd2a2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd2a2f",
  null
  
)

export default component.exports